<template>
  <div class="sector-submit-bar-wrapper flex justify-flex-end align-center">
    <div class="questions-info">Questions: {{answeredQuestions}}/{{ totalQuestions }}</div>
    <div class="submit-button">
      <el-button type="sector" :disabled="answeredQuestions < totalQuestions" @click="changeSector">
        <span v-if="nextSector != null">Next: {{nextSector.name}}</span>
        <span v-else>Finish</span>
        <i class="el-icon-arrow-right el-icon-right"></i></el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectorSubmitBar',
  computed: {
    user() {
      return this.$store.getters.user
    },
    activeSector() {
      return this.$store.getters.activeSector
    },
    totalQuestions() {
      if (this.activeSector) {
        return this.activeSector.appraisalQuestions.length
      } 
      return 0
    },
    answers() {
      return this.$store.getters.answers
    },
    answeredQuestions() {
      if (this.answers && this.activeSector && this.answers[this.activeSector.id]) {
        return this.answers[this.activeSector.id].length
      }
      return 0
    },
    nextSector() {
      if (this.$store.getters.gameplay) {
        const activeIndex = this.$store.getters.activeSectorIndex
        const sectors = this.$store.getters.gameplay.appraisalSectors
        if (sectors[activeIndex+1]) {
          return sectors[activeIndex+1]
        }
      }
      
      return null
    }
  },
  methods: {
    async changeSector() {
      // Send all answers from this sector
      const obj = {
        sectorId: this.activeSector.id,
        assessmentId: this.$store.getters.playerResultId,
        answers: []
      }

      this.answers[this.activeSector.id].forEach(element => {
        const ansObj = {
          value: element.value,
          questionId: element.questionId,
          comment: element.comment
        }
        obj.answers.push(ansObj);
      });
      const response = await this.$store.dispatch('setAnswers', obj)

      if (response.data === 'next-sector') {
        // Move to new sector
        this.$router.go()
      } else {
        // finish it
        this.$router.go()
      }

      
    }
  }
}
</script>

<style lang="scss">
  @import "~vars";
  .sector-submit-bar-wrapper {
    background: white;
    width: 100%;
    position: fixed;
    bottom: 0;
    box-shadow: 0px -6px 34px 0px #0000000A;
    height: 60px;
    .questions-info {
      font-weight: 700;
    }
    .submit-button {
      margin: 0 20px;
      button {
        i {
          margin-right: 10px;
        }
      }
    }
  }
</style>
